// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_V8v","cls2":"UserCard-cls2_qtM UserCard-cls1_V8v"};